/**
 * The Cooked Sushi — trust strip mobile carousel indicators
 */
(function () {
  function initCarousel(root) {
    if (root.dataset.trustReady === 'true') return;

    const track = root.querySelector('[data-trust-track]');
    const indicators = root.querySelectorAll('[data-trust-indicator]');
    const beacons = track ? track.querySelectorAll('.nihooya-trust-strip__beacon') : [];

    if (!track || indicators.length === 0 || beacons.length === 0) return;

    root.dataset.trustReady = 'true';

    let ticking = false;

    function setActive(index) {
      indicators.forEach((button, i) => {
        const active = i === index;
        button.classList.toggle('is-active', active);
        if (active) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    }

    function getActiveIndex() {
      const scrollLeft = track.scrollLeft;
      let closest = 0;
      let minDistance = Infinity;

      beacons.forEach((beacon, index) => {
        const distance = Math.abs(beacon.offsetLeft - scrollLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closest = index;
        }
      });

      return closest;
    }

    function scrollToBeacon(index) {
      const beacon = beacons[index];
      if (!beacon) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      track.scrollTo({
        left: beacon.offsetLeft,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    }

    track.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          setActive(getActiveIndex());
          ticking = false;
        });
      },
      { passive: true }
    );

    indicators.forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.index);
        scrollToBeacon(index);
        setActive(index);
      });
    });

    setActive(0);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-trust-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();